import { datadogRum } from '@datadog/browser-rum';
import { useEffect } from 'react';
import { Switch, Route, Redirect, useLocation } from 'react-router-dom';
import * as Pages from 'app/pages';

import { constants } from 'app/utils';
import { ProtectedRoute } from './ProtectedRoute';

export const Routes: React.FC = () => {
  const isSignposted = window.CONFIG.signposting?.maintenanceMode;
  const location = useLocation();

  useEffect(() => {
    const resolvedLocation = location.hash || location.pathname || '/';

    datadogRum.startView(resolvedLocation);
  }, [location]);

  if (isSignposted) {
    // If maintenance mode is enabled, show the Maintenance page for all routes
    return (
      <Switch>
        <Route path={constants.Routes.Others}>
          <Pages.Maintenance />
        </Route>
      </Switch>
    );
  } else {
    return (
      <Switch>
        <Redirect exact from={constants.Routes.Root} to={constants.Routes.Home} />
        <Route exact path={constants.Routes.Home}>
          <Pages.Home />
        </Route>
        <ProtectedRoute path={constants.Routes.Redemption}>
          <Pages.Redemption />
        </ProtectedRoute>
        <Route exact path={constants.Routes.AccountCallback}>
          <Pages.AccountCallback />
        </Route>
        <ProtectedRoute path={constants.Routes.Dashboard}>
          <Pages.Dashboard />
        </ProtectedRoute>
        <ProtectedRoute path={constants.Routes.ProviderDetailsTransaction}>
          <Pages.ProviderDetailsTransaction />
        </ProtectedRoute>
        <Route exact path={constants.Routes.TechnicalError}>
          <Pages.TechnicalError />
        </Route>
        <ProtectedRoute path={constants.Routes.ChangeAuthorisedContact}>
          <Pages.ChangeAuthorisedContact />
        </ProtectedRoute>
        <Route path={constants.Routes.Others}></Route>
      </Switch>
    );
  }
};
